// extracted by mini-css-extract-plugin
export default {"submitButton":"theme_submitButton__urOrn"};